<template>
  <div
    class="ly_appSize un_phoneView_wrapper __bgWhite hp_posiRel hp_mH_vh"
    v-if="feed"
  >
    <!-- 모달 (바텀시트) .__show 추가시 오픈 -->
    <article
      class="bl_modal_wrapper __bottomSheet __show"
      v-show="downloadModalShown"
      @click.stop="downloadModalShown = false"
    >
      <div class="bl_modal_dimed"></div>
      <!-- only Mobile -->
      <div class="bl_modal __onlyMobile" @click.stop="null">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <img src="/images/oeApp.svg" v-auto-title alt="오이 로고 이미지" />
            <h2>앱에서 더 구경할 수 있어요<br />앱에서 볼까요?</h2>
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <a class="el_btn" target="_blank" :href="storeLink">앱으로 보기</a>
          <button
            class="el_btn __light"
            @click.stop="downloadModalShown = false"
          >
            닫기
          </button>
        </section>
      </div>
      <!-- only PC -->
      <div class="bl_modal __onlyPC" @click.stop="null">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <QRCode :value="storeLink"></QRCode>
            <h2>앱에서 더 구경할 수 있어요</h2>
            <span
              >스마트폰 카메라로 QR코드를 비추면<br />다운로드 페이지로
              연결돼요</span
            >
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <button
            class="el_btn __light"
            @click.stop="downloadModalShown = false"
          >
            닫기
          </button>
        </section>
      </div>
    </article>

    <h1 class="blind">
      {{
        feed.description?.length > 0
          ? truncateString(feed.description, 35)
          : feed.gatheringInfo.title
      }}
    </h1>

    <!-- 모달 (바텀시트) .__show 추가시 오픈 -->
    <article class="bl_modal_wrapper __bottomSheet">
      <div class="bl_modal_dimed"></div>
      <!-- only Mobile -->
      <div class="bl_modal __onlyMobile">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <img src="/images/oeApp.svg" v-auto-title alt="오이 로고 이미지" />
            <h2>앱에서 더 구경할 수 있어요<br />앱에서 볼까요?</h2>
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <a class="el_btn" target="_blank" :href="storeLink">앱으로 보기</a>
          <button class="el_btn __light">닫기</button>
        </section>
      </div>
      <!-- only PC -->
      <div class="bl_modal __onlyPC">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <QRCode :value="storeLink"></QRCode>
            <h2>앱에서 더 구경할 수 있어요</h2>
            <span
              >스마트폰 카메라로 QR코드를 비추면<br />다운로드 페이지로
              연결돼요</span
            >
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <button class="el_btn __light">닫기</button>
        </section>
      </div>
    </article>

    <!-- 탑 바 -->
    <header class="bl_topBar">
      <a class="bl_topBar_logo" @click="goTo('/')"></a>
      <ul class="bl_topBar_nav">
        <!-- <li><a href="introduceOE.html">앱 소개</a></li> -->
        <!-- <li><a href="">취미 모임</a></li> -->
        <!-- <li><a href="">소통 공간</a></li> -->
      </ul>
    </header>

    <section class="un_feedList_item __detailVer" style="margin-bottom: 32px">
      <div class="un_feedList_desc">
        <figure class="el_profile hp_mb12">
          <!-- <img
            :src="feed.author.getImage"
            v-auto-title alt="유저 프로필"
            @click="downloadModalShown = true"
          /> -->
          <CustomProfileImage
            :src="feed.author.image"
            v-auto-title
            alt="유저 프로필"
            @click="downloadModalShown = true"
          ></CustomProfileImage>
          <figcaption @click="downloadModalShown = true">
            {{ feed.author.nickname }}
          </figcaption>
        </figure>
        <NuxtLink
          class="un_feedList_gathering"
          :to="`/gathering/${feed.gatheringInfo.id}`"
        >
          <CustomImage
            :src="feed.gatheringInfo.image"
            alt="모임 이미지"
          ></CustomImage>
          <!-- <img :src="feed.gatheringInfo.image" v-auto-title alt="모임 이미지" /> -->
          <dl>
            <dt>{{ feed.gatheringInfo.title }}</dt>
            <dd>{{ feed.gatheringInfo.region }}</dd>
          </dl>
        </NuxtLink>
        <p>
          {{ feed.description }}
        </p>
      </div>
      <feed-carousel
        :images="feed.images"
        @click="downloadModalShown = true"
      ></feed-carousel>
      <div class="bl_reactionSection" style="padding-left: 16px">
        <i class="bl_reaction __chat" @click="downloadModalShown = true">{{
          feed.commentInfo.count
        }}</i>
        <i class="bl_reaction __heart" @click="downloadModalShown = true">{{
          feed.likeInfo.count
        }}</i>
      </div>
    </section>

    <section class="bl_commentSection" v-show="feed.commentInfo.count > 0">
      <h2 class="bl_commentSection_ttl">
        <strong>댓글</strong> {{ feed.commentInfo.count }}
      </h2>
      <div
        class="bl_commentSection_item"
        v-for="(comment, index) in feed.commentInfo.list"
        :key="index"
      >
        <figure class="el_profile hp_mb8">
          <!-- <img
            :src="comment.author.getImage"
            v-auto-title alt="유저 프로필"
            @click="downloadModalShown = true"
          /> -->
          <CustomProfileImage
            :src="comment.author.image"
            v-auto-title
            alt="유저 프로필"
            @click="downloadModalShown = true"
          ></CustomProfileImage>
          <figcaption @click="downloadModalShown = true">
            {{ comment.author.nickname }}
          </figcaption>
        </figure>
        <p>
          {{ comment.description }}
        </p>
        <div class="bl_reactionSection">
          <i class="bl_reaction __chat" @click="downloadModalShown = true">{{
            comment.recommentInfo.count
          }}</i>
          <i class="bl_reaction __heart" @click="downloadModalShown = true">{{
            comment.likeInfo.count
          }}</i>
        </div>
        <button
          v-show="comment.recommentInfo.count > 0"
          class="bl_commentSection_reply"
          @click="downloadModalShown = true"
        >
          댓글 {{ comment.recommentInfo.count }}개
        </button>
      </div>
    </section>
  </div>
</template>

<script setup lang="tsx">
import { useGetStoreLink } from "~/composable/useGetStoreLink";
import api from "../../../utils/api";
import type GatheringFeedDetailPublic from "./gathering-feed-detail-public.dto";

const feedId = Number(useRoute().params.id);
if (!Number.isInteger(feedId)) {
  throw new Error("잘못된 접근입니다.");
}

const downloadModalShown = ref(false);

const feed = ref<GatheringFeedDetailPublic>(null as any);

const _asyncData = await useAsyncData("getGatheringFeedDetail", async () => {
  const { result, value } = await api.getGatheringFeedDetail(feedId);
  return { result, value };
});
if (_asyncData.data.value?.value) {
  feed.value = _asyncData.data.value.value;
} else {
  await navigateTo("/gathering/notfound", { redirectCode: 301 });
}

const truncateString = (str: string, maxLength: number) => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  }
  return str;
};

if (feed.value) {
  // 검색 이용자는 `광주광역시 서구` 로 검색하지 않고 `광주`, `서구` 로 검색한다. (스펙 §2-2)
  // 기존 title 에는 지역어도 모임명도 없어서 "광주 골프 모임" 류 조합 검색에 걸리지 않았다.
  // 일정 제목을 본문보다 앞세운다. 모임장이 요약해 쓴 문장이라 지명·활동명이 앞에 온다. (스펙 §4-3)
  useHead({
    title: buildFeedTitle({
      scheduleTitle: feed.value.schedule?.title,
      body: feed.value.description,
      gatheringName: feed.value.gatheringInfo.title,
      region: splitRegion(feed.value.gatheringInfo.region),
    }),
    meta: [
      // 피드 본문에는 정산 내역이 그대로 올라온다. (`입금 계좌 신한은행 110-*** 김대성`)
      // meta description 은 검색결과에 그대로 노출되므로 연락처·계좌를 걷어낸다. (스펙 §7-2)
      { name: "description", content: buildDescription(feed.value.description) },
      { property: "og:title", content: "모임 커뮤니티 - 오이" },
      { property: "og:description", content: feed.value.description },
      {
        property: "og:image",
        content:
          (typeof feed.value.images[0] === "string"
            ? feed.value.images[0]
            : feed.value.images[0].thumbnailUrl) ||
          "https://oe-app.com/images/og-image.png",
      },
    ],
    link: [
      { rel: "canonical", href: `https://oe-app.com/gathering/feed/${feedId}` },
    ],
    script: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            organizationSchema,
            softwareAppSchema,
            gatheringFeedDetailSchema({
              id: feed.value.id,
              content: feed.value.description,
              author: {
                id: feed.value.author.id,
                name: feed.value.author.nickname,
                profileImage: feed.value.author.image,
              },
              gathering: {
                id: feed.value.gatheringInfo.id,
                name: feed.value.gatheringInfo.title,
              },
              images: feed.value.images.map((image) =>
                typeof image === "string" ? image : image.thumbnailUrl
              ),
              publishDate: feed.value.createdAt.toISOString(),
              likeCount: feed.value.likeInfo.count,
              commentCount: feed.value.commentInfo.count,
              comments: feed.value.commentInfo.list.map((cmt) => ({
                id: cmt.id,
                author: {
                  id: cmt.author.id,
                  name: cmt.author.nickname,
                  profileImage: cmt.author.image,
                },
                content: cmt.description,
                publishDate: cmt.createdAt.toISOString(),
              })),
            }),
          ],
        }),
      },
    ],
  });
}

const goTo = (path: string) => {
  useRouter().push(path);
};

const storeLink = computed(() => {
  if (feed.value) {
    return useGetStoreLink(
      deeplink.gatheringFeedDetail(feed.value.gatheringInfo.id, feedId)
    );
  } else {
    return "";
  }
});
</script>

<style scoped>
@import "@/assets/css/seo.css";
@import "@/assets/css/base.css";
</style>
